/** Dedicated Football Subs Stripe price (USD $8/mo default, with EUR/GBP
 * currency options on the same price). Override via env for sandbox. */
export const STRIPE_PREMIUM_PRICE_ID =
  import.meta.env.VITE_PUBLIC_STRIPE_PRICE_ID || 'price_1UEEotBW2j61o9CsBWeK6WfN';
